import styled from '@emotion/styled';

export const Main = styled.main<{}>`
	display: block;
`;
